import { useAuth } from '../context/AuthContext';
import EditAvatar from '../components/Profile/AvatarHandler/EditAvatar'; 
import DisplayAvatar from '../components/Profile/AvatarHandler/DisplayAvatar';
import { useState, useEffect } from 'react';
import EmailForm from '../components/Profile/CredentialHandler/EmailForm';
import PasswordForm from '../components/Profile/CredentialHandler/PasswordForm';
import { defaultAvatarOptions } from '../utils/constants/avatar';

function ProfilePage() {
    const { user, updateUser } = useAuth();
    const [showAvatarEditor, setShowAvatarEditor] = useState(false);
    const [avatarOptions, setAvatarOptions] = useState(null);

    const valueOfAvatarOptions = (user) => {
        if (!user || user.avatarOptions === undefined || (Object.keys(user.avatarOptions).length === 0)) {
            return defaultAvatarOptions;
        } else {
            return user.avatarOptions;
        }
    }

    useEffect(() => {
        if (user) {
            setAvatarOptions(valueOfAvatarOptions(user));
        }
    }, [user]);

    const handleAvatarChange = (user) => {
        updateUser(user); 
        setAvatarOptions(user.avatarOptions);
        setShowAvatarEditor(false); 
    };

    const toggleAvatarEditor = () => {
        setShowAvatarEditor(!showAvatarEditor);
    };

    if (!user) {
        return  <div className="flex justify-center items-center min-h-screen bg-gray-100">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-32 w-32 border-t-4 border-primary border-solid"></div>
                        <p className="mt-4 text-xl text-gray-700 font-semibold">Chargement...</p>
                    </div>
                </div>
    }

    return (
        <div className="max-w-md mx-auto p-4 bg-white rounded-lg mt-12 min-h-screen text-center">
            <h1 className="text-xl text-center font-semibold text-gray-800 mt-4">Bienvenue {user.pseudo}</h1>
            {user.role !== "admin" && (
                <p className="text-sm text-gray-500 py-4">
                    Votre pseudo a été concocté spécialement pour vous, avec un adjectif, une couleur et un animal...✨
                </p>
            )}
            {user.email}
            <div className="flex justify-center"> 
                {showAvatarEditor ? (
                    <EditAvatar avatarOptions={avatarOptions} onAvatarChange={handleAvatarChange} />
                ) : (
                    <DisplayAvatar avatarOptions={avatarOptions} toggleAvatarEditor={toggleAvatarEditor}/>
                )}
            </div>
            <EmailForm/>
            <PasswordForm/>
        </div>
    );
}

export default ProfilePage;
